module.exports = __webpack_public_path__ + "img/Temperatura.748864e0.png";